import React, { useState, useEffect } from "react";
import "./Contact.scss";
import Layout from "../../components/Layout";
import bgim from "../../images/cot.jpg";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { FaBuilding } from "react-icons/fa6";
import emailjs from '@emailjs/browser';

function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    subject: "Appointment Inquiry"
  });

  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      name: `${formData.firstName} ${formData.lastName}`,  // For {{name}}
      from_name: `${formData.firstName} ${formData.lastName}`, // For {{from_name}}
      message: formData.message,
      email: formData.email, // ✅ VERY IMPORTANT — required for {{email}} and reply-to
      timestamp: new Date().toLocaleString()
    };

    emailjs.send(
      'service_dbr196n', // ✅ Your service ID
      'template_lxvrnje',  // ✅ Replace with your actual template ID
      templateParams,
      'x9lvZTfrWo6eMW-tx' // ✅ Your public key
    )
    .then((response) => {
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 4000); // Hide after 4 seconds
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
        subject: "Appointment Inquiry"
      });
    })
    .catch((error) => {
      console.error("Email send error:", error);
      alert("Failed to send message.");
    });
  };

  return (
    <Layout>
      <div
        className="contact-us"
        style={{
          backgroundImage: `url(${bgim})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="contact-container">
          <div className="contact-info">
            <h2>Contact Information</h2>
            <p>Fill out the form and hit the send message button. We'll get back to you soon!</p>
            <div className="info-item">
              <FaPhoneAlt className="cicon" />
              <p>613-979-2402</p>
            </div>
            <div className="info-item">
              <FaEnvelope className="cicon" />
              <p>mantraflexwellness@gmail.com</p>
            </div>
            <div className="info-item">
              <FaMapMarkerAlt className="cicon" />
              <p>2201 Riverside Dr., Ottawa, ON K1H 8K9 (Head Office)</p>
            </div>
            {/* <div className="info-item">
              <FaBuilding className="cicon" />
              <p>6206 Perth St unit e, Richmond, ON K0A 2Z0 (In-Clinic)</p>
            </div> */}
          </div>

          <div className="contact-form">
            <h2>Contact Us</h2>
            {showSuccess && (
              <div className="custom-alert success">
                <span>✅ Your message has been sent successfully!</span>
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <input type="email" name="email" placeholder="E-Mail" value={formData.email} onChange={handleChange} required />
                <input type="tel" name="phone" placeholder="Phone #" value={formData.phone} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <textarea name="message" placeholder="Message" value={formData.message} onChange={handleChange} required></textarea>
              </div>
              <button type="submit">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Contact;
